// import React from 'react'

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

// import Navbar from '../navbar/Navbar'
import Header2 from '../header2/Header2'
import Partners2 from '../partners2/Partners2'
import Products from '../products/Products'
import Rds2 from '../rds2/Rds2'
import SectionBlog from '../sectionBlog/SectionBlog'
import Projects2 from '../projects2/Projects2'

import AboutUs from '../aboutus/AboutUs'
import Team from '../team/Team'
import SectionTeam from '../sectionTeam/SectionTeam';
import Hiring1 from '../hiring2/Hiring1'
import Footer2 from '../footer2/Footer2'

function Home() {

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const scrollTo = query.get('scrollTo');

  useEffect(() => {
   
    
    if (scrollTo) {
      window.history.replaceState({}, document.title, '/');
    }
    if (scrollTo) {
      let retries = 0;
      const maxRetries = 20; 
      const scrollToSection = () => {
        const targetElement = document.getElementById(scrollTo);
        if (targetElement) {
        
          scroller.scrollTo(scrollTo, {
            smooth: true,
            offset: 0, 
            duration: 500,
          });
         
          window.history.replaceState({}, document.title, '/');
        } else if (retries < maxRetries) {
         
          retries++;
          setTimeout(scrollToSection, 100); 
        } 
      };
      
      setTimeout(scrollToSection, 1000); 
    }
  }, [scrollTo]);

  return (
    <section>
       {/* <Navbar/>  */}
       <div id='homeNavApp'>
            <Header2/>
       </div>
      
       <Partners2/>
        <div id='productsNavApp'>
            <Products/>
        </div>
        <div id='servicesNavApp'>
          <Rds2/>
        </div>
        <div id='projectsNavApp'>
            <Projects2/>
        </div>
         <div id='aboutNavApp'>
           <AboutUs/>
         </div>
       
       <Team/>
       <SectionTeam/>

        <SectionBlog/>
         <div id='careersNavApp'>
            <Hiring1/>
         </div>
       
      <Footer2/>
    </section>
  )
}

export default Home
